var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { request } from '../../config/request';
/**
 * Права на вкладки деканата: поиск, журнал, отчёты, разрешения.
 * Загружаются один раз в App и читаются и меню, и самой страницей —
 * раньше запрос жил внутри MainPage, поэтому боковое меню о правах не знало.
 */
export const fetchControlPerm = createAsyncThunk('control-perm/fetch', (id_avn_user, thunkApi) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { data } = yield request(`/dekanat/jurnal-control-perm?id_avn_user=${id_avn_user}`, 'POST');
        return data || [];
    }
    catch (e) {
        return thunkApi.rejectWithValue('Ошибка');
    }
}));
